import { get } from 'lodash'
import { TinyMceEditor } from 'libs/tv3-platform/src/lib/components/TinyMceEditor/options'
import { Injectable, NgZone } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { EditorImageDialogService } from './editor-image-dialog.service'

@Injectable({
  providedIn: SharedModule,
})
export class EditorImageDialogPatchService {
  constructor(private ngZone: NgZone, private editorImageDialog: EditorImageDialogService) {}

  patchEditorWindowOpen(editor: TinyMceEditor) {
    const _open = editor.windowManager.open

    editor.windowManager.open = (...args) => {
      if (args[0].title === 'Insert/Edit Image') {
        return this.ngZone.run(() => this.handleImage(editor, args[0]))
      }

      return _open.call(editor.windowManager, ...args)
    }
  }

  handleImage(editor: TinyMceEditor, options: any) {
    const data = get(options, ['initialData'])
    const src = get(data, ['src', 'value']) || ''
    const alt = get(data, ['alt']) || ''
    const width = +get(data, ['dimensions', 'width']) || null
    const height = +get(data, ['dimensions', 'height']) || null

    this.editorImageDialog
      .open({
        image: { src, alt, width, height },
      })
      .subscribe(({ image }) => {
        if (!image) return

        const data = {
          src: image.src || '',
          alt: image.alt || '',
          width: image.width || '',
          height: image.height || '',
        }

        editor.execCommand('mceUpdateImage', false, data)
      })
  }
}
